var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCare = function SvgCare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#fff",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M28 20a8 8 0 0 1-8 8v2c5.523 0 10-4.477 10-10zm-8 8a8 8 0 0 1-8-8h-2c0 5.523 4.477 10 10 10zm-8-8a8 8 0 0 1 8-8v-2c-5.523 0-10 4.477-10 10zm8-8a8 8 0 0 1 8 8h2c0-5.523-4.477-10-10-10zm3 8a3 3 0 0 1-3 3v2a5 5 0 0 0 5-5zm-3 3a3 3 0 0 1-3-3h-2a5 5 0 0 0 5 5zm-3-3a3 3 0 0 1 3-3v-2a5 5 0 0 0-5 5zm3-3a3 3 0 0 1 3 3h2a5 5 0 0 0-5-5zm5.657-4.071-3.536 3.536 1.415 1.414 3.535-3.536zM22.12 23.535l3.536 3.536 1.414-1.414-3.536-3.536zm-4.242-7.07-3.536-3.536-1.414 1.414 3.536 3.536zm-1.415 5.656-3.535 3.536 1.414 1.414 3.536-3.536z"
  })));
};
export default SvgCare;